import { render, staticRenderFns } from "./label-usage.vue?vue&type=template&id=e07f485e"
import script from "./label-usage.vue?vue&type=script&lang=js"
export * from "./label-usage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports